import '../welcomeModal/Modal.scss';

const WelcomeModalContent = ({ isMainnet = false }) => {
  return (
    <div className="welcome-modal-content">
      <h3 className="welcome-modal-title">
        {isMainnet
          ? _t('Welcome to Cables Finance on Avalanche', 'MODAL.WELCOME_TITLE')
          : _t('Welcome to Cables Finance on Avalanche Testnet', 'MODAL.WELCOME_TITLE_TESTNET')}
      </h3>
      <p className="welcome-modal-description">
        {isMainnet
          ? _t(
              'Thanks for using Cables Finance. Check out our mainnet guide below to start trading.',
              'MODAL.WELCOME_THANKS_FOR_USING'
            )
          : _t(
              'Thanks for participating in the Cables Testnet, where we aim to identify bugs and usability issues. You can try the app with the Testnet assets that have no value and make swap & pool transactions.',
              'MODAL.WELCOME_THANKS_FOR_USING_TESTNET'
            )}
      </p>
      {isMainnet && (
        <a
          href="https://cables-finance-1.gitbook.io/cables.finance/avalanche-get-started/mainnet-guide"
          target="_blanck"
          className="welcome-modal-link"
        >
          {_t('Mainnet Guide', 'MODAL.LINK_GUIDE')}
        </a>
      )}

      <a href="https://discord.com/invite/UCAhKKz9qD" target="_blanck" className="welcome-modal-link">
        {_t('Discord', 'MODAL.LINK_DISCORD')}
      </a>
      <a href="https://twitter.com/CablesFinance" target="_blanck" className="welcome-modal-link">
        {_t('Twitter', 'MODAL.LINK_TWITTER')}
      </a>
      <a
        href="https://cables-finance-1.gitbook.io/cables.finance/support/faq"
        target="_blanck"
        className="welcome-modal-link"
      >
        {_t('FAQs', 'MODAL.LINK_FAQS')}
      </a>
      <p className="welcome-modal-sub-description">
        {_t('You can join the community to report bugs & feedback.', 'MODAL.WELCOME_JOIN_COMMUNITY')}
      </p>
    </div>
  );
};

export default WelcomeModalContent;
